import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormArray, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ComfortType } from 'src/app/models/comfort.mode';
import { StorageAcceptance, StorageAcceptanceSingleValue, StorageAcceptancePerComfortType } from 'src/app/models/StorageAcceptance.model';
import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';
import { CloneService } from 'src/app/services/clone.service';
import { LuggageType } from 'src/app/models/luggageType.model';
import { StorageSpaceSingle } from 'src/app/models/StorageSpaces.model';
import { IdValue } from 'src/app/matrix-component/grid-list/idvalue.model';
import { GridWithId } from './GridWithId.model';
import { ComfortTypeEnum } from 'src/app/models/enums/ComfortTypeEnum';
import { dynamicLocaleCompareWithOptions } from 'src/app/helper/sortFunctions';

@Component({
  selector: 'app-storage-acceptance',
  templateUrl: './storage-acceptance.component.html',
  styleUrls: ['./storage-acceptance.component.scss']
})
export class StorageAcceptanceComponent implements OnInit {
  @Input('form') parentForm: FormGroup;
  @Input('data') data: StorageAcceptance;
  @Input('comfortTypes') comfortTypes: ComfortType[];
  @Input('colHeaders') colHeaders: LuggageType[];
  @Input('rowHeaders') rowHeaders: StorageSpaceSingle[];
  @Input('isEditable') isEditable: boolean;

  form: FormGroup;
  lascCtrl;
  test: boolean = false;
  gridDataList: GridWithId[] = [];
  currentComfortTypeId: number = 1;

  constructor(private _formBuilder: FormBuilder, private cloneService: CloneService) { }

  ngOnInit() {
    this.form = this.parentForm;
    this.form.addControl('storageAcceptance', this._formBuilder.array([]));
    this.form.setControl('storageAcceptance', this.dataAsFormArray());
    this.lascCtrl = this.form.get('storageAcceptance');
    this.data.storageAcceptancePerComfortTypeList = this.lascCtrl.value as StorageAcceptancePerComfortType[];
    this.comfortTypes = this.comfortTypes.filter(f => f.id != ComfortTypeEnum.Default).sort((a, b) => dynamicLocaleCompareWithOptions(a, b, 'name'));;
    this.addGrids();
  }

  addGrids() {
    for (let i = 0; i < this.data.storageAcceptancePerComfortTypeList.length; i++) {
      const element = this.data.storageAcceptancePerComfortTypeList[i];
      this.gridDataList.push(new GridWithId(element.comfortTypeId, this.ConvertData(element.storageAcceptanceValueList)));
    }
  }

  dataAsFormArray(): FormArray {
    const fgs = this.data.storageAcceptancePerComfortTypeList.map(o => this.asFormGroup(o));
    return new FormArray(fgs);
  }
  asFormGroup(o: StorageAcceptancePerComfortType): FormGroup {
    const fg = new FormGroup({
      comfortTypeId: new FormControl(o.comfortTypeId, Validators.required),
      storageAcceptanceValueList: new FormControl(o.storageAcceptanceValueList, Validators.required),
    });
    return fg;
  }
  ConvertData(data: StorageAcceptanceSingleValue[]): GridData {
    let matrix: StorageAcceptanceSingleValue[] = [];
    for (let i = 0; i < data.length; i++) {
      const element = data[i];
      let single: StorageAcceptanceSingleValue = new StorageAcceptanceSingleValue();
      single.value = element.value;
      // single.value=Math.round(element.value * 100);
      single.storageSpaceId = element.storageSpaceId + 1;
      single.luggageTypeId = element.luggageTypeId + 1;
      matrix.push(single);
    }
    let rowHeaders: IdValue[] = [];
    for (let i = 0; i < this.rowHeaders.length; i++) {
      const headerEntry = this.rowHeaders[i];
      rowHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }
    let colHeaders: IdValue[] = [];
    for (let i = 0; i < this.colHeaders.length; i++) {
      const headerEntry = this.colHeaders[i];
      colHeaders.push(new IdValue(headerEntry.id + 1, headerEntry.name));
    }
    let grid: GridData = new GridData();
    grid.colHeaders = colHeaders;
    grid.rowHeaders = rowHeaders;
    grid.matrix = matrix;
    grid.colProp = 'luggageTypeId';
    grid.rowProp = 'storageSpaceId';
    grid.switchColWithRow = false;
    return grid;
  }
  ConvertDataBack(temp: GridWithId[]) {
    let list: StorageAcceptancePerComfortType[] = [];
    for (let i = 0; i < temp.length; i++) {
      const element = temp[i];
      let perComfortType: StorageAcceptancePerComfortType = new StorageAcceptancePerComfortType();
      perComfortType.comfortTypeId = element.comfortTypeId;

      let singleValuesList: StorageAcceptanceSingleValue[] = [];
      for (let j = 0; j < element.grid.matrix.length; j++) {
        const element2 = element.grid.matrix[j] as StorageAcceptanceSingleValue;
        let singleValues: StorageAcceptanceSingleValue = new StorageAcceptanceSingleValue();
        singleValues.luggageTypeId = element2.luggageTypeId - 1;
        singleValues.storageSpaceId = element2.storageSpaceId - 1;
        singleValues.value = element2.value;
        // singleValues.value=element2.value / 100;
        singleValuesList.push(singleValues);
      }

      perComfortType.storageAcceptanceValueList = singleValuesList;
      list.push(perComfortType);
    }
    this.data.storageAcceptancePerComfortTypeList = list;
  }
  save() {
    let clonedGridDataList = this.cloneService.deepClone(this.gridDataList) as GridWithId[];
    this.ConvertDataBack(clonedGridDataList);
    if (this.lascCtrl !== null) {
      this.lascCtrl.patchValue(this.data.storageAcceptancePerComfortTypeList);
    }
  }
}
